<template>
	<sf-data-table
		ref="compMstTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="compMstCols"
		:rows="rows"
		index
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:selection="false"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		@changedRow="changedRow"
		@row-click="rowClick"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		compMstCols() {
			return [
				{
					label: this.getMessage_('QWCC001108'), //업체구분
					prop: 'cpnyScnNm',
					width: '90px',
					sortable: true,
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000950'), // 업체코드
					prop: 'cpnyCd',
					width: '100px',
					headerAlign: 'center',
					sortable: true,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000951'), // 업체명
					prop: 'cpnyNm',
					width: '170px',
					headerAlign: 'center',
					sortable: true,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001593'), // 업체담당자
					prop: 'userName',
					width: '100px',
					headerAlign: 'center',
					sortable: true,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000059'), // 부품유형
					prop: 'partTypeNm',
					width: '100px',
					headerAlign: 'center',
					sortable: true,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001538'), // 제품ID
					prop: 'custProdNo',
					width: '120px',
					headerAlign: 'center',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000061'), // 연락처
					prop: 'crgrTn',
					width: '170px',
					sortable: true,
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001161'), // 이메일주소
					prop: 'eml',
					width: '220px',
					sortable: true,
					maxlength: 50,
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC002091'), // 이메일주소
					prop: 'ssClassNm',
					width: '120px',
					sortable: true,
					maxlength: 10,
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC000060'), // FAX번호
					prop: 'fax',
					width: '170px',
					sortable: true,
					maxlength: 13,
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001162'), // 지역
					prop: 'regn',
					width: '100px',
					sortable: true,
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001164'), // 주소
					prop: 'adr',
					width: '400',
					sortable: true,
					maxlength: 13,
					headerAlign: 'center',
					align: 'left'
				},
				{
					label: this.getMessage_('QWCC001913'), // 정렬순서
					prop: 'sortNo',
					width: '80px',
					sortable: true,
					headerAlign: 'center',
					maxlength: 13,
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001163'), // 사용여부
					prop: 'useYn',
					minWidth: '80px',
					sortable: true,
					headerAlign: 'center',
					align: 'center',
					form: {
						type: 'select',
						options: this.useYnList
					}
				}
			];
		},
		insVali() {
			return yup.array().of(
				yup.object().shape({
					partsNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000904')]))
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수

			let queryStr = '';

			queryStr = objectToQuerystring({
				cpnyScn: this.searchParams.cpnyScn,
				cpnyNm: this.searchParams.cpnyNm,
				useYn: this.searchParams.useYn
			});

			const url = `${BASE_URL}/comm/qmsbase/compMst/v1/compMsts/excel` + queryStr;

			const params = { url, columns: this.compMstCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		changedRow({ rows, changedRow }) {
			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		},
		rowClick(row) {
			this.setStateClear_();
			row.readOnlyAuth = true;
			let rowClickData = _.cloneDeep(row);
			this.setState_({ key: 'masterInfo', value: rowClickData });
		}
	}
};
</script>

<style></style>
